import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from '@common/composables'
    import { useAccessSharePage } from '@DataSharing/Shares/pages-core'
    import '@common/Components/ValidationError.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AccessSharePage',
  setup(__props) {

    document.title = 'Access TransparentChoice'

    const id = useRoute().params.id
    const email = ref()

    const { useAccessShareQuery, useSendEmailConfirmationCommand } = useAccessSharePage()
    
    const { modelAccessShareQueryV1, runAccessShareQueryV1 } = useAccessShareQuery(id)
    const { invokeSendEmailConfirmationCommandV1, succeedSendEmailConfirmationCommandV1, validationErrors } = useSendEmailConfirmationCommand(id, email)

    const isEmailAuthorized = computed(() => modelAccessShareQueryV1.value?.IsEmailAuthorized)
    const isAuthenticatedUser = computed(() => modelAccessShareQueryV1.value?.IsAuthenticatedUser)
    const organizationName = computed(() => modelAccessShareQueryV1.value?.OrganizationUnitName)
    const organizationUnitId = computed(() => modelAccessShareQueryV1.value?.OrganizationUnitId)
    const workspaceName = computed(() => modelAccessShareQueryV1.value?.WorkspaceName)
    const projectName = computed(() => modelAccessShareQueryV1.value?.ProjectName)
    const resourceName = computed(() => modelAccessShareQueryV1.value?.ResourceName)
    const isAccessable = computed(() => modelAccessShareQueryV1.value?.IsAccessable)
    const accessUrl = computed(() => modelAccessShareQueryV1.value?.AccessUrl)
    const accessIssueDetails = computed(() => modelAccessShareQueryV1.value?.AccessIssueDetails)

    runAccessShareQueryV1()

return { __sfc: true,id, email, useAccessShareQuery, useSendEmailConfirmationCommand, modelAccessShareQueryV1, runAccessShareQueryV1, invokeSendEmailConfirmationCommandV1, succeedSendEmailConfirmationCommandV1, validationErrors, isEmailAuthorized, isAuthenticatedUser, organizationName, organizationUnitId, workspaceName, projectName, resourceName, isAccessable, accessUrl, accessIssueDetails }
}

})